module.exports = __webpack_public_path__ + "img/reifenstapel.4ac0124f.svg";